// The one same-origin PocketBase handle for the whole SPA, plus the credential
// helpers every other api/ module builds on.
//
// The UI is served by the same binary that serves the API (`ui/serve.go`), so
// the base URL is the current origin: no base URL is baked into the bundle and
// no token is embedded in it. The SDK's default LocalAuthStore persists the
// session token in localStorage and re-attaches it to the framework-native
// auth routes automatically; the custom `/v1/*` and `/api/cloud/auth/*` routes
// need it attached explicitly, which is what `authHeader` is for
// (`06` §2.1: every credential class travels as `Authorization: Bearer …`).

import PocketBase from "pocketbase";

/**
 * pb is the shared PocketBase client. It owns the session token and is the
 * transport for the three framework-native auth routes (`request-otp`,
 * `auth-with-otp`, `auth-refresh`, `06` §1.2). Everything else in the product
 * goes through `api/http.ts`, because `06` §1.6 locks auto-REST (nil API rules)
 * and every access path is an explicit Go route.
 */
export const pb = new PocketBase(window.location.origin);

/** authStore is re-exported for the auth guard and the account chrome. */
export const authStore = pb.authStore;

/**
 * authHeader returns the `Authorization` header for the custom API routes,
 * which — unlike auto-REST — need the token passed explicitly. Returns an empty
 * object when there is no valid session, so an anonymous route
 * (`POST /v1/invites/lookup`, the passkey login pair) never sends a stale
 * bearer token that would produce a 401 unrelated to the request.
 */
export function authHeader(): Record<string, string> {
  return pb.authStore.isValid ? { Authorization: "Bearer " + pb.authStore.token } : {};
}

/** isSignedIn reports whether a non-expired session token is stored. */
export function isSignedIn(): boolean {
  return pb.authStore.isValid;
}
